<template>
    <div ref="container">
        <a-modal 
            :title="title" 
            width="95%" 
            :visible="visible" 
            :confirmLoading="confirmLoading" 
            :maskStyle="{'top':'93px','left':'154px'}" 
            :maskClosable="false" 
            @ok="handleOk" 
            @cancel="handleCancel"
            @close="closeModal" 
            cancelText="关闭" 
            style="top:50px;height: 90%;"
        >
            <!-- <a-list>
                <a-list-item  v-for="(item, index) in listData" :key="index">
                    <span>{{item.traceCode}}</span>
                    <a-button type="link" @click="viewDetails(item)">查看商品列表</a-button>
                    <a-button type="link" @click="viewTraceDetails(item)">查看追溯详情</a-button>
                </a-list-item>
            </a-list> -->
            <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="uuid"
                :columns="eventColumns"
                :dataSource="listData"
                :pagination="eventIpagination"
                @change="handleEventChange">
                <span slot="action" slot-scope="text, record">
                  <a @click="viewDetails(record)">查看商品列表</a>
                  <a-divider type="vertical" />
                  <a @click="viewTraceDetails(record)">查看追溯详情</a>
                </span>
            </a-table>
            <!-- 物码列表模态框 -->
            <a-modal :visible="detailVisible" width="95%" title="商品码列表" @ok="handleDetailOk" @cancel="handleDetailCancel">
                <a-table
                    ref="table"
                    size="middle"
                    bordered
                    rowKey="uuid"
                    :columns="columns"
                    :dataSource="details"
                    :pagination="ipagination"
                    @change="handleTableChange">
                </a-table>
            </a-modal>
            <!-- 追溯详情模态框 -->
            <a-modal :visible="traceDetailVisible" width="95%" title="追溯详细信息" @ok="handleTraceDetailOk" @cancel="handleTraceDetailCancel">
                <a-list-item  v-for="(item, index) in traceDetails" :key="index">
                    <span>{{item.name}}</span>
                    <template v-if="isImageUrl(item.value)">
                        <img :src="item.value" alt="图片" style="max-width: 100px; max-height: 100px; margin-left: 10px;" @click="showOriginalImage(item.value)"/>
                    </template>
                    <template v-else>
                        <span>{{ item.value }}</span>
                    </template>
                </a-list-item>
            </a-modal>
            <!-- 新增的模态框用于展示原图 -->
            <a-modal :visible="originalImageVisible" :footer="null" @cancel="handleOriginalImageCancel">
                <img :src="originalImageUrl" alt="原图" style="width: 100%; height: auto;" />
            </a-modal>
        </a-modal>
    </div>
</template>
<script>
// import pick from 'lodash.pick'
import GetTraceCode from '@/views/identifierCode/getTraceCode';
import { getEventListByProcessId, getObjectDetaillist } from '@/api/api'
export default {
    name: 'CustomerModal',
    components: {
        GetTraceCode
    },
    data () {
        return {
            title: '追溯信息',
            visible: false, 
            detailVisible: false, 
            traceDetailVisible: false, 
            confirmLoading: false,
            originalImageVisible: false,
            originalImageUrl: '',
            processId: '',
            selectedItem: {},
            details: [],
            model: {},
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
            },
            listData:[],
            traceDetails:[],
            columns: [
                {
                    title: '序号',
                    dataIndex: '',
                    key:'rowIndex',
                    width: '5%',
                    align:"center",
                    customRender:function (t,r,index) {
                        return parseInt(index)+1;
                        //  return (this.ipagination.current - 1) * this.ipagination.pageSize + index + 1;
                    }
                },
                { title: '商品码', dataIndex: 'objectCode', key: 'objectCode' }
            ],
            eventColumns: [
                {
                    title: '序号',
                    dataIndex: '',
                    key:'rowIndex',
                    width: '5%',
                    align:"center",
                    customRender:function (t,r,index) {
                        return parseInt(index)+1;
                        //  return (this.ipagination.current - 1) * this.ipagination.pageSize + index + 1;
                    }
                },
                { 
                    title: '事件码', 
                    dataIndex: 'traceCode', 
                    key: 'traceCode' 
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    width: '30%',
                    align:"center",
                    scopedSlots: { customRender: 'action' },
                }
            ],
            ipagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => {
                    return range[0] + '-' + range[1] + ' 共' + total + '条'
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
            },
            eventIpagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => {
                    return range[0] + '-' + range[1] + ' 共' + total + '条'
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0
            },
        }
    },
    computed: {
        // paginatedData() {
        //     const { current, pageSize } = this.pagination;
        //     const start = (current - 1) * pageSize;
        //     const end = start + pageSize;
        //     return this.details.slice(start, end);
        // }
    },
    methods: {
        show(e){
            this.visible = true
            console.log(e,'e===================')
            this.processId = e.id
            this.getTraceList(e.id)
        },
        // 获取追溯事件码列表
        async getTraceList(id){
            let pageNo = this.ipagination.current
            let pageSize = this.ipagination.pageSize
            const params = { 
                traceProdProcessId: this.processId,
                pageNo: pageNo,
                pageSize: pageSize
            }
            const res = await getEventListByProcessId(params)
            if( res.code == 200 && res.success == true ){
                this.listData = res.result.records
            }
        },
        handleOk() {
          this.visible = false;
        },
        handleCancel(){
          this.visible = false;
        },
        closeModal(){
          this.visible = false;
        },
        viewDetails(item) {
            this.selectedItem = item;
            this.detailVisible = true;
            this.getEventTraceDetail(item.traceCode)
            console.log(item,'item===================')
        },
        viewTraceDetails(item) {
            this.selectedItem = item;
            this.traceDetailVisible = true;
            this.getEventTraceDetail(item.traceCode)
            console.log(item,'item===================')
        },
        handleTableChange(pagination, filters, sorter) {
            this.ipagination.current = pagination.current;
            this.ipagination.pageSize = pagination.pageSize;

            // 如果需要处理排序或过滤，可以在这里添加逻辑
            this.getEventTraceDetail(this.selectedItem.traceCode);
        },
        handleEventChange(pagination, filters, sorter) {
            this.eventIpagination.current = pagination.current;
            this.eventIpagination.pageSize = pagination.pageSize;

            // 如果需要处理排序或过滤，可以在这里添加逻辑
            this.getTraceList(this.processId);
        },
        async getEventTraceDetail(traceCode){
            let pageNo = this.ipagination.current
            let pageSize = this.ipagination.pageSize
            const params = { 
                eventCode: traceCode,
                currentPage: pageNo,
                pageSize: pageSize
            }
            const res = await getObjectDetaillist(params)
            if( res.code == 200 && res.success == true ){
                this.details = res.result.data
                this.traceDetails = res.result.data[0].records.event
                this.ipagination.total = res.result.total
            }
        },
        // 判断是否为图片 URL
        isImageUrl(value) {
            const imageExtensions = /\.(jpeg|jpg|png|gif|bmp|svg)$/i;
            return imageExtensions.test(value);
        },
        handleDetailOk(){
            this.detailVisible = false;
        },
        handleDetailCancel(){
            this.detailVisible = false;
        },
        handleTraceDetailOk(){
            this.traceDetailVisible = false;
        },
        handleTraceDetailCancel(){
            this.traceDetailVisible = false;
        },
        showOriginalImage(url) {
            this.originalImageUrl = url;
            this.originalImageVisible = true;
        },
        handleOriginalImageCancel() {
            this.originalImageVisible = false;
        }
    }
}
</script>
<style lang="less" scoped>

</style>